import { render, staticRenderFns } from "./CustomizeMetalAB.vue?vue&type=template&id=6e356bef&scoped=true"
import script from "./CustomizeMetalAB.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalAB.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalAB.vue?vue&type=style&index=0&id=6e356bef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e356bef",
  null
  
)

export default component.exports